import { ChangeDetectorRef, Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Catalog } from './models/catalog.interface';
import { catalog } from './data/catalog';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-catalog-offers',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './catalog-offers.component.html',
  styleUrls: ['./catalog-offers.component.scss']
})
export class CatalogOffersComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('catalogOffers', { static: false }) catalogOffers?: ElementRef;
  catalogs: Catalog[] = [];

  constructor(private cdr: ChangeDetectorRef, private analyticsService: AnalyticsService) {
    this.catalogs = [];
    this.cdr.markForCheck();
    this.cargarCatalogos();
    console.log(this.catalogs);
  }

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.catalogOffers?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.catalogOffers.nativeElement,
        'Catalog Offers',
        'catalog-offers-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }

  // Método para trackear click en catálogo
  onCatalogClick(catalog: any): void {
    this.analyticsService.trackCTAClick(
      `Ver catálogo ${catalog.title}`,
      'Catalog Offers',
      'link',
      {
        catalog_name: catalog.title,
        catalog_url: catalog.url,
        catalog_id: catalog.id
      }
    );
  }
  cargarCatalogos() {
    this.catalogs = [{
      id: 1,
      title: 'Unimarc',
      url: 'https://www.unimarc.cl/page/catalogo',
      image: 'https://www.unipay.cl/api/descargaArchivo/web-catalogo-unimarc.png',
      backgroundColor: 'transparent',
      width: '413px',
      height: '263px'
    },{
      id: 2,
      title: 'Super 10',
      url: 'https://www.super10.cl/catalogo',
      image: 'https://www.unipay.cl/api/descargaArchivo/web-catalogo-super10.png',
      backgroundColor: 'transparent',
      width: '413px',
      height: '263px'
    },{
      id: 3,
      title: 'Alvi',
      url: 'https://www.alvi.cl/page/catalogo',
      image: 'https://www.unipay.cl/api/descargaArchivo/web-catalogo-alvi.png',
      backgroundColor: 'transparent',
      width: '413px',
      height: '263px'
    }]
  }
}
